import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "px-6 md:px-8 pt-6 pb-20 max-w-5xl" }
const _hoisted_2 = {
  key: 0,
  class: "text-sm text-red-600",
  role: "alert"
}
const _hoisted_3 = {
  key: 1,
  class: "rounded-xl border border-gray-200 bg-white px-6 py-5"
}

import { computed, onMounted, ref } from 'vue'

import NeueLoading from '@/components/neue/NeueLoading.vue'
import ParsleyNewItemsTab from '@/components/parsley/ParsleyNewItemsTab.vue'
import ParsleyProductsTab from '@/components/parsley/ParsleyProductsTab.vue'
import ParsleyRunBanner from '@/components/parsley/ParsleyRunBanner.vue'
import SecondaryNav from '@/components/SecondaryNav.vue'
import SecondaryTop from '@/components/SecondaryTop.vue'
import { useParsleyTabs } from '@/composables/useParsleyTabs'
import { INTEGRATIONS_PATH } from '@/config/settingsTabs'
import { showLatestParsleyRun } from '@/helpers/parsleyRunTracker'
import { errorMessage, parsleyApi } from '@/services/parsleyApi'

const LOAD_ERROR = "Couldn't load Parsley. Please refresh the page."


export default {
  __name: 'ParsleyMapping',
  setup(__props) {

const { tabs, tab } = useParsleyTabs()

const loading = ref(true)
const loadError = ref('')
const connection = ref(null)

const connected = computed(() => Boolean(connection.value?.attributes?.turned_on))

// A refresh clears the tracker, so the last run is looked up again. Failing to
// find it leaves the banner empty; it does not stop the tabs.
const showLatestRun = async () => {
  try {
    await showLatestParsleyRun({ fetchRuns: parsleyApi.runs, fetchRun: parsleyApi.run })
  } catch {
    // Nothing to show.
  }
}

onMounted(async () => {
  try {
    connection.value = await parsleyApi.connection()
  } catch (failure) {
    loadError.value = errorMessage(failure, LOAD_ERROR)
  } finally {
    loading.value = false
  }
  if (connected.value) await showLatestRun()
})

return (_ctx, _cache) => {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock(SecondaryNav, null, {
    top: _withCtx(() => [
      _createVNode(SecondaryTop, {
        text: "Parsley",
        sections: _unref(tabs)
      }, null, 8, ["sections"])
    ]),
    main: _withCtx(() => [
      _createVNode(NeueLoading, { loading: loading.value }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            (loadError.value)
              ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(loadError.value), 1))
              : (!connected.value)
                ? (_openBlock(), _createElementBlock("section", _hoisted_3, [
                    _cache[1] || (_cache[1] = _createElementVNode("h2", { class: "text-base font-semibold text-gray-900" }, "Connect Parsley first", -1)),
                    _cache[2] || (_cache[2] = _createElementVNode("p", { class: "mt-1 text-sm text-gray-600" }, " Add your Parsley API key in Settings, then come back here to link your products. ", -1)),
                    _createVNode(_component_router_link, {
                      to: _unref(INTEGRATIONS_PATH),
                      class: "mt-3 inline-block text-sm font-medium text-brand-600 hover:text-brand-700"
                    }, {
                      default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                        _createTextVNode(" Go to Settings ", -1)
                      ]))]),
                      _: 1
                    }, 8, ["to"])
                  ]))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    _createVNode(ParsleyRunBanner),
                    (_unref(tab) === 'products')
                      ? (_openBlock(), _createBlock(ParsleyProductsTab, { key: 0 }))
                      : (_openBlock(), _createBlock(ParsleyNewItemsTab, { key: 1 }))
                  ], 64))
          ])
        ]),
        _: 1
      }, 8, ["loading"])
    ]),
    _: 1
  }))
}
}

}